import useGetRewardRewardType from './useGetRewardRewardType'

export default useGetRewardRewardType
